import { render, staticRenderFns } from "./Copilot.vue?vue&type=template&id=6fe829a0"
import script from "./Copilot.vue?vue&type=script&lang=js"
export * from "./Copilot.vue?vue&type=script&lang=js"
import style0 from "./Copilot.vue?vue&type=style&index=0&id=6fe829a0&prod&lang=scss"
import style1 from "./Copilot.vue?vue&type=style&index=1&id=6fe829a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports